// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-delete-swal-container {
  background: var(--overlay-default, rgba(10, 22, 20, 0.44)) !important;
}

.app-delete-swal {
  display: grid !important;
  grid-template-columns: 46px minmax(0, 1fr) 32px;
  width: min(440px, calc(100vw - 32px)) !important;
  padding: 24px !important;
  border: 1px solid var(--border-subtle, #dce3e2) !important;
  border-radius: var(--radius-lg, 14px) !important;
  background: var(--surface-primary, #fff) !important;
  box-shadow: var(
    --elevation-xl,
    0 24px 48px -12px rgba(14, 26, 32, 0.24)
  ) !important;
  color: var(--text-primary, #142624) !important;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  overflow: hidden;
}

.app-delete-swal-icon {
  grid-column: 1;
  grid-row: 1;
  width: 36px !important;
  height: 36px !important;
  margin: 0 !important;
  border: 0 !important;
  border-radius: var(--radius-full, 9999px) !important;
  background: var(--danger-soft, #fff1ef) !important;
  color: var(--danger-text, #b42318) !important;
}

.app-delete-swal-icon svg {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.app-delete-swal-title {
  grid-column: 2;
  grid-row: 1;
  align-self: center;
  padding: 0 !important;
  color: var(--text-primary, #142624) !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  line-height: 25px !important;
  text-align: left !important;
}

.app-delete-swal-close {
  grid-column: 3;
  grid-row: 1;
  position: static !important;
  width: 32px !important;
  height: 32px !important;
  color: var(--text-secondary, #506360) !important;
  font-size: 26px !important;
}

.app-delete-swal-body {
  grid-column: 1 / -1;
  margin: 20px 0 0 !important;
  padding: 0 !important;
  color: var(--text-secondary, #506360) !important;
  font-size: 14px !important;
  line-height: 22px !important;
  text-align: left !important;
}

.app-delete-swal-actions {
  grid-column: 1 / -1;
  justify-content: flex-end !important;
  width: 100% !important;
  margin: 24px 0 0 !important;
  padding: 0 !important;
  gap: 8px;
}

.app-delete-swal-cancel,
.app-delete-swal-confirm {
  height: 40px;
  margin: 0 !important;
  padding: 0 16px;
  border-radius: var(--radius-md, 10px);
  font: 500 14px/1 var(--font-family-primary, "Lexend", sans-serif);
  cursor: pointer;
}

.app-delete-swal-cancel {
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
}

.app-delete-swal-confirm {
  border: 0;
  background: var(--danger-soft, #fff1ef);
  color: var(--danger-text, #b42318);
}

.app-delete-swal-cancel:hover {
  background: var(--surface-tertiary, #e8edec);
}

.app-delete-swal-confirm:hover {
  background: var(--danger-soft, #fff1ef);
  color: var(--danger-text, #b42318);
  filter: brightness(0.98);
}

.app-delete-swal.dark {
  --surface-primary: #191b1f;
  --surface-tertiary: #2b2f35;
  --border-default: #3a3f47;
  --border-subtle: #2c3036;
  --text-primary: #f2f3f5;
  --text-secondary: #adbab7;
}

@media (max-width: 600px) {
  .app-delete-swal {
    border-radius: var(--radius-lg, 14px) !important;
  }

  .app-delete-swal-actions {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
  }

  .app-delete-swal-cancel,
  .app-delete-swal-confirm {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SwalAlert/swalPopupWithButtons.css"],"names":[],"mappings":"AAAA;EACE,qEAAqE;AACvE;;AAEA;EACE,wBAAwB;EACxB,+CAA+C;EAC/C,gDAAgD;EAChD,wBAAwB;EACxB,0DAA0D;EAC1D,gDAAgD;EAChD,mDAAmD;EACnD;;;cAGY;EACZ,8CAA8C;EAC9C,wEAAwE;EACxE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,oDAAoD;EACpD,kDAAkD;EAClD,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,8CAA8C;EAC9C,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,gDAAgD;EAChD,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,gDAAgD;EAChD,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;EACrB,QAAQ;AACV;;AAEA;;EAEE,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,qCAAqC;EACrC,iEAAiE;EACjE,eAAe;AACjB;;AAEA;EACE,gDAAgD;EAChD,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,uCAAuC;EACvC,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".app-delete-swal-container {\n  background: var(--overlay-default, rgba(10, 22, 20, 0.44)) !important;\n}\n\n.app-delete-swal {\n  display: grid !important;\n  grid-template-columns: 46px minmax(0, 1fr) 32px;\n  width: min(440px, calc(100vw - 32px)) !important;\n  padding: 24px !important;\n  border: 1px solid var(--border-subtle, #dce3e2) !important;\n  border-radius: var(--radius-lg, 14px) !important;\n  background: var(--surface-primary, #fff) !important;\n  box-shadow: var(\n    --elevation-xl,\n    0 24px 48px -12px rgba(14, 26, 32, 0.24)\n  ) !important;\n  color: var(--text-primary, #142624) !important;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  overflow: hidden;\n}\n\n.app-delete-swal-icon {\n  grid-column: 1;\n  grid-row: 1;\n  width: 36px !important;\n  height: 36px !important;\n  margin: 0 !important;\n  border: 0 !important;\n  border-radius: var(--radius-full, 9999px) !important;\n  background: var(--danger-soft, #fff1ef) !important;\n  color: var(--danger-text, #b42318) !important;\n}\n\n.app-delete-swal-icon svg {\n  width: 20px;\n  height: 20px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.app-delete-swal-title {\n  grid-column: 2;\n  grid-row: 1;\n  align-self: center;\n  padding: 0 !important;\n  color: var(--text-primary, #142624) !important;\n  font-size: 18px !important;\n  font-weight: 600 !important;\n  line-height: 25px !important;\n  text-align: left !important;\n}\n\n.app-delete-swal-close {\n  grid-column: 3;\n  grid-row: 1;\n  position: static !important;\n  width: 32px !important;\n  height: 32px !important;\n  color: var(--text-secondary, #506360) !important;\n  font-size: 26px !important;\n}\n\n.app-delete-swal-body {\n  grid-column: 1 / -1;\n  margin: 20px 0 0 !important;\n  padding: 0 !important;\n  color: var(--text-secondary, #506360) !important;\n  font-size: 14px !important;\n  line-height: 22px !important;\n  text-align: left !important;\n}\n\n.app-delete-swal-actions {\n  grid-column: 1 / -1;\n  justify-content: flex-end !important;\n  width: 100% !important;\n  margin: 24px 0 0 !important;\n  padding: 0 !important;\n  gap: 8px;\n}\n\n.app-delete-swal-cancel,\n.app-delete-swal-confirm {\n  height: 40px;\n  margin: 0 !important;\n  padding: 0 16px;\n  border-radius: var(--radius-md, 10px);\n  font: 500 14px/1 var(--font-family-primary, \"Lexend\", sans-serif);\n  cursor: pointer;\n}\n\n.app-delete-swal-cancel {\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n}\n\n.app-delete-swal-confirm {\n  border: 0;\n  background: var(--danger-soft, #fff1ef);\n  color: var(--danger-text, #b42318);\n}\n\n.app-delete-swal-cancel:hover {\n  background: var(--surface-tertiary, #e8edec);\n}\n\n.app-delete-swal-confirm:hover {\n  background: var(--danger-soft, #fff1ef);\n  color: var(--danger-text, #b42318);\n  filter: brightness(0.98);\n}\n\n.app-delete-swal.dark {\n  --surface-primary: #191b1f;\n  --surface-tertiary: #2b2f35;\n  --border-default: #3a3f47;\n  --border-subtle: #2c3036;\n  --text-primary: #f2f3f5;\n  --text-secondary: #adbab7;\n}\n\n@media (max-width: 600px) {\n  .app-delete-swal {\n    border-radius: var(--radius-lg, 14px) !important;\n  }\n\n  .app-delete-swal-actions {\n    display: grid !important;\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .app-delete-swal-cancel,\n  .app-delete-swal-confirm {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
